import { type TableRow } from '../../../data/leagueTable';
import { teamGradient } from '../../../lib/teams';
import { cn } from '../../../lib/cn';
import { BORDER_COLOR } from './constants';

export function StaticTableView({ table, season }: { table: { asOf: string; rows: TableRow[] }; season?: number }) {
  return (
    <>
      <div className="flex items-center justify-between pt-[18px] pb-3">
        <span className="text-[15px] font-extrabold tracking-[-0.02em] text-ink">Standings · {season ? `${season}/${(season + 1) % 100}` : '2025/26'}</span>
        <span className="text-[12px] font-medium text-ink2">{table.asOf}</span>
      </div>

      {/* column header */}
      <div className="px-2">
        <div className="flex items-center gap-[10px] pb-2">
          <span className="w-[18px] text-center text-[10px] font-bold text-ink3">#</span>
          <span className="flex-1 text-[10px] font-bold tracking-[0.04em] text-ink3">CLUB</span>
          <span className="w-7 text-center text-[10px] font-bold text-ink3">P</span>
          <span className="w-[34px] text-center text-[10px] font-bold text-ink3">GD</span>
          <span className="w-[30px] text-center text-[10px] font-bold text-ink3">PTS</span>
        </div>
      </div>

      <div className="overflow-hidden rounded-[20px] border border-black/7 bg-white">
        {table.rows.map((row) => (
          <TableRowView key={row.code} row={row} />
        ))}
      </div>
    </>
  );
}

function TableRowView({ row }: { row: TableRow }) {
  const accent = row.border ? BORDER_COLOR[row.border] : undefined;
  const gdColor = row.gd > 0 ? 'text-accent-ink' : row.gd < 0 ? 'text-danger' : 'text-ink2';
  const gdLabel = row.gd > 0 ? `+${row.gd}` : row.gd < 0 ? `−${Math.abs(row.gd)}` : '0';

  return (
    <>
      {row.gapBefore && (
        <div className="flex items-center justify-center gap-[5px] py-[7px]">
          <span className="h-[3px] w-[3px] rounded-full bg-ink4" />
          <span className="h-[3px] w-[3px] rounded-full bg-ink4" />
          <span className="h-[3px] w-[3px] rounded-full bg-ink4" />
        </div>
      )}
      {row.dividerBefore === 'CHAMPIONS LEAGUE' && <ZoneLine label="CHAMPIONS LEAGUE" color="#1E5BB8" />}
      {row.dividerBefore === 'RELEGATION' && <ZoneLine label="RELEGATION" color="#D2544F" />}
      <div
        className="flex items-center gap-[10px] px-[14px] py-[9px]"
        style={accent ? { borderLeft: `3px solid ${accent}` } : undefined}
      >
        <span className="num w-[18px] text-center text-[13px] font-extrabold text-ink">{row.rank}</span>
        <div className="grid h-[26px] w-[26px] place-items-center rounded-[7px] text-[8px] font-extrabold text-white" style={{ backgroundImage: teamGradient(row.code) }}>{row.code}</div>
        <span className="flex-1 text-[13px] font-bold tracking-[-0.01em] text-ink">{row.name}</span>
        <span className="num w-7 text-center text-[12px] font-semibold text-ink2">{row.played}</span>
        <span className={cn('num w-[34px] text-center text-[12px] font-bold', gdColor)}>{gdLabel}</span>
        <span className="num w-[30px] text-center text-[14px] font-extrabold text-ink">{row.points}</span>
      </div>
    </>
  );
}

function ZoneLine({ label, color }: { label: string; color: string }) {
  return (
    <div className="flex items-center gap-2 px-[14px] py-1" style={{ background: `${color}10` }}>
      <div className="h-px flex-1" style={{ background: `${color}40` }} />
      <span className="text-[9px] font-extrabold tracking-[0.08em]" style={{ color }}>{label}</span>
      <div className="h-px flex-1" style={{ background: `${color}40` }} />
    </div>
  );
}
